module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Devices/Display#1-cdcae1d5bbfa082155c1abad10a588e0.svg";